import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import AppleStore from "@catchy/assets/svgs/app-store.svg";
import GooglePlay from "@catchy/assets/svgs/google-play.svg";
import NonAppPageShell from "./NonAppPageShell";
function ExternalLink(t0) {
  const $ = _c(3);
  const {
    href,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== href) {
    t1 = <a href={href} className="text-blue-500">{children}</a>;
    $[0] = children;
    $[1] = href;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function TechnologyCredits(t0) {
  const $ = _c(24);
  const {
    dataCredits: t1,
    includeSnapper: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const dataCredits = t3;
  const includeSnapper = t2 === undefined ? false : t2;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ExternalLink href="https://nextjs.org/">Next.js</ExternalLink>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ExternalLink href="https://swr.vercel.app/">SWR</ExternalLink>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li>{t4} and{" "}{t5} by{" "}<ExternalLink href="https://vercel.com/">Vercel</ExternalLink></li>;
    t7 = <ExternalLink href="https://tailwindcss.com/">Tailwind CSS</ExternalLink>;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ExternalLink href="https://headlessui.dev/">Headless UI</ExternalLink>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t10;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <li>{t7}{" "}and{" "}{t8}{" "}by{" "}<ExternalLink href="https://github.com/tailwindlabs">Tailwind Labs</ExternalLink></li>;
    t10 = <ExternalLink href="https://react-spring.io/">React Spring</ExternalLink>;
    $[7] = t10;
    $[8] = t9;
  } else {
    t10 = $[7];
    t9 = $[8];
  }
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ExternalLink href="https://use-gesture.netlify.app/">@use-gesture</ExternalLink>;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  let t13;
  let t14;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li>{t10}{" "}and{" "}{t11}{" "}by <ExternalLink href="https://pmnd.rs/">Poimandres</ExternalLink></li>;
    t13 = <li><ExternalLink href="https://maplibre.org/">MapLibre GL JS</ExternalLink></li>;
    t14 = <ExternalLink href="https://www.digitalocean.com/">DigitalOcean Managed Database</ExternalLink>;
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
  } else {
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
  }
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <li>{t14}{" "}and{" "}<ExternalLink href="https://orm.drizzle.team/">Drizzle ORM</ExternalLink></li>;
    t16 = <li><ExternalLink href="https://openweathermap.org/">OpenWeatherMap</ExternalLink></li>;
    t17 = <li><ExternalLink href="https://developer.apple.com/xcode/swiftui/">SwiftUI</ExternalLink></li>;
    t18 = <li><ExternalLink href="https://github.com/features/actions">GitHub Actions</ExternalLink></li>;
    $[13] = t15;
    $[14] = t16;
    $[15] = t17;
    $[16] = t18;
  } else {
    t15 = $[13];
    t16 = $[14];
    t17 = $[15];
    t18 = $[16];
  }
  let t19;
  if ($[17] !== dataCredits) {
    t19 = dataCredits.map(_temp);
    $[17] = dataCredits;
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  let t20;
  if ($[19] !== includeSnapper) {
    t20 = includeSnapper && <li><ExternalLink href="https://www.snapper.co.nz/">Snapper</ExternalLink>’s{" "}<ExternalLink href="https://card-holder.snapper.co.nz/v1/cards/">APIs</ExternalLink></li>;
    $[19] = includeSnapper;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] !== t19 || $[22] !== t20) {
    t21 = <ul className="mb-4 list-disc space-y-1 pl-5">{t6}{t9}{t12}{t13}{t15}{t16}{t17}{t18}{t19}{t20}</ul>;
    $[21] = t19;
    $[22] = t20;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  return t21;
}
function _temp(credit) {
  return <li key={credit.name}><ExternalLink href={credit.href}>{credit.name}</ExternalLink>{credit.apiHref && <>’s <ExternalLink href={credit.apiHref}>APIs</ExternalLink></>}</li>;
}
export default function AboutPage(t0) {
  const $ = _c(41);
  const {
    appName: t1,
    regionName,
    agencyName,
    canonicalUrl,
    description,
    shareImage,
    modesLabel: t2,
    appsDescription: t3,
    googlePlayUrl,
    appleStoreUrl,
    includeWatchCredit: t4,
    includeAutomationCredit: t5,
    includeSnapper: t6,
    dataCredits: t7
  } = t0;
  const appName = t1 === undefined ? "Catchy" : t1;
  const modesLabel = t2 === undefined ? "buses and trains" : t2;
  const appsDescription = t3 === undefined ? "Apps are available for Android, iPhone and Apple Watch." : t3;
  const includeWatchCredit = t4 === undefined ? true : t4;
  const includeAutomationCredit = t5 === undefined ? false : t5;
  const includeSnapper = t6 === undefined ? false : t6;
  let t8;
  if ($[0] !== t7) {
    t8 = t7 === undefined ? [] : t7;
    $[0] = t7;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const dataCredits = t8;
  const pageDescription = description || `Find out more about ${regionName}’s favourite free public transport app.`;
  const t9 = `About ${appName}`;
  let t10;
  if ($[2] !== appName) {
    t10 = <h1 className="mb-4 text-3xl font-semibold">About {appName}</h1>;
    $[2] = appName;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  let t11;
  if ($[4] !== agencyName || $[5] !== appName || $[6] !== regionName) {
    t11 = <p className="mb-4">{appName} is a free, independent and private alternative to {agencyName}’s apps for people who take public transport in {regionName}.</p>;
    $[4] = agencyName;
    $[5] = appName;
    $[6] = regionName;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== modesLabel) {
    t12 = <p className="mb-4">Catchy helps regular travellers feel more confident in using public transport by focusing on timely and relevant information about the{" "}{modesLabel} that they take.</p>;
    $[8] = modesLabel;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  let t14;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="mb-4">Find the stops you use most and add them to your favourites. Check to see if your service is running on time and watch its progress live on a map.</p>;
    t14 = <p className="font-semibold">Catchy is:</p>;
    $[10] = t13;
    $[11] = t14;
  } else {
    t13 = $[10];
    t14 = $[11];
  }
  let t15;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ul className="mb-4 list-disc space-y-1 pl-5"><li>accurate</li><li>fast and accessible</li><li>mobile-first</li><li>constantly improving</li><li><Link href="/privacy" className="text-blue-500">private</Link></li></ul>;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="mb-4">For updates, follow{" "}<ExternalLink href="https://bsky.app/profile/catchy.nz">@catchy.nz</ExternalLink>{" "}on Bluesky.</p>;
    $[13] = t16;
  } else {
    t16 = $[13];
  }
  let t17;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <p className="mb-12">Feedback is welcome, either on Bluesky or to{" "}<ExternalLink href="mailto:feedback@catchy.nz">feedback@catchy.nz</ExternalLink>.</p>;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] !== appleStoreUrl || $[16] !== appsDescription || $[17] !== googlePlayUrl) {
    t18 = (googlePlayUrl || appleStoreUrl) && <><h2 className="mb-4 text-lg font-semibold">Apps</h2><p className="mb-2">{appsDescription}</p><div className="mb-12 flex gap-x-4">{googlePlayUrl && <a href={googlePlayUrl} className="font-semibold text-blue-500"><GooglePlay width="135" height="40" /></a>}{appleStoreUrl && <a href={appleStoreUrl} className="font-semibold text-blue-500"><AppleStore /></a>}</div></>;
    $[15] = appleStoreUrl;
    $[16] = appsDescription;
    $[17] = googlePlayUrl;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h2 className="mb-4 text-lg font-semibold">Credits</h2>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <p className="mb-4">Apps, Design, illustration and custom fonts by{" "}<ExternalLink href="https://david.buck.nz">David Buck</ExternalLink>.</p>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] !== includeWatchCredit) {
    t21 = includeWatchCredit && <p className="mb-4">Apple Watch development by Isaac Young.</p>;
    $[21] = includeWatchCredit;
    $[22] = t21;
  } else {
    t21 = $[22];
  }
  let t22;
  if ($[23] !== includeAutomationCredit) {
    t22 = includeAutomationCredit && <p className="mb-12">Update automation by Andrew Connell and Stuart King.</p>;
    $[23] = includeAutomationCredit;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <h2 className="mb-2 font-semibold">Technology used:</h2>;
    $[25] = t23;
  } else {
    t23 = $[25];
  }
  let t24;
  if ($[26] !== dataCredits || $[27] !== includeSnapper) {
    t24 = <TechnologyCredits dataCredits={dataCredits} includeSnapper={includeSnapper} />;
    $[26] = dataCredits;
    $[27] = includeSnapper;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  let t25;
  if ($[29] !== canonicalUrl || $[30] !== pageDescription || $[31] !== shareImage || $[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t18 || $[36] !== t21 || $[37] !== t22 || $[38] !== t24 || $[39] !== t9) {
    t25 = <NonAppPageShell title={t9} description={pageDescription} canonicalUrl={canonicalUrl} image={shareImage} className="pb-8">{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}</NonAppPageShell>;
    $[29] = canonicalUrl;
    $[30] = pageDescription;
    $[31] = shareImage;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t18;
    $[36] = t21;
    $[37] = t22;
    $[38] = t24;
    $[39] = t9;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  return t25;
}